import React, { useEffect, useState } from "react";
import { clearCurrentVehicleAssignmentDetail } from "Redux/Dashboard/slice";
import { useAppDispatch } from "Redux/store";
import VehicleAssignment from "./VehicleAssignment";
import VehicleAssignmentDetail from "./VehicleAssignmentDetail";

const VehicleAssignmentDashboard = () => {
  const dispatch = useAppDispatch();
  const [detailVehicleAssignment, setDetailVehicleAssignment] =
    useState<boolean>(false);
  const [assignmentId, setAssignmentId] = useState<string | null>(null);

  const openDetailVehicleAssignment = () => setDetailVehicleAssignment(true);
  const closeDetailVehicleAssignment = () => {
    setDetailVehicleAssignment(false);
    // Clicking the same assignment again reopens it.
    setAssignmentId(null);
  };

  useEffect(
    () => () => {
      dispatch(clearCurrentVehicleAssignmentDetail());
    },
    [dispatch],
  );

  return (
    <>
      <VehicleAssignment
        assignmentId={assignmentId}
        setAssignmentId={setAssignmentId}
        closeDetailAssigment={closeDetailVehicleAssignment}
        openDetailAssigment={openDetailVehicleAssignment}
      />
      <VehicleAssignmentDetail
        open={detailVehicleAssignment}
        closeModal={closeDetailVehicleAssignment}
      />
    </>
  );
};

export default VehicleAssignmentDashboard;
